import React from 'react'
import PropTypes from 'prop-types'

import MessageFile from './MessageFile'
import FilePreview from './FilePreview'

function MessageFiles({ files }) {
  return (
    files.map((file, index) => (
      <div className="attachment__column col-xs-12 col-sm-6 col-md-4 col-lg-3" key={`file-attachment-wrap-${index}`}>
        <div className="attachment__wrapper">
          <FilePreview
            fileName={file.attributes.fileName}
            iconName="file-archive"
            fileUrl={file.attributes.url}
            download
          />
          <MessageFile file={file} />
        </div>
      </div>
    ))
  )
}

MessageFiles.propTypes = {
  files: PropTypes.array.isRequired,
}

export default MessageFiles
